<template>
  <p>{{ t('comps.action_counter_contact', { actions: String(actions || 0), emails: String(emails || 0), some: String(some || 0), name: first_name || t('shared.animal_friend') }) }}</p>
</template>

<script lang="ts" setup>
const { api_endpoint } = useRuntimeConfig().public
const { first_name } = useUserStore()

const { data: emails } = useFetch<number>(`${api_endpoint}/user/action/count`, {
  method: 'POST',
  body: JSON.stringify({ action_type: 'contact', action_platform: 'email' }),
})
const { data: some } = useFetch<number>(`${api_endpoint}/user/action/count`, {
  method: 'POST',
  body: JSON.stringify({ action_type: 'contact', action_platform: 'some' }),
})
const { data: actions } = useFetch<number>(`${api_endpoint}/user/action/count`, {
  method: 'POST',
  body: JSON.stringify({ action_type: 'contact' }),
})
</script>
